// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ash Terminal Theme - Based on ash terminal styling */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

html, body {
  height: 100%;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Courier New', 'Consolas', 'Liberation Mono', monospace;
}

/* Global scrollbar styling - black theme */
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: #000000;
  border-left: 1px solid #1a1a1a;
}

::-webkit-scrollbar-thumb {
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #3a3a3a;
}

/* Firefox scrollbar */
* {
  scrollbar-width: thin;
  scrollbar-color: #2a2a2a #000000;
}

body {
  background: #000000;
  color: #00ff41;
  line-height: 1.6;
  position: relative;
  overflow-x: hidden;
}

/* Background Video */
#background-video {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  z-index: -1;
  object-fit: cover;
  opacity: 0.3; /* Adjust opacity for readability */
}

/* Video overlay for better text readability */
#root::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Dark overlay */
  z-index: -1;
  pointer-events: none;
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

/* Header */
.header {
  background: #000000;
  border-bottom: 1px solid #1a1a1a;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h1 {
  font-size: 24px;
  color: #00ff41;
  font-weight: 600;
}

.nav {
  display: flex;
  gap: 20px;
}

.nav a {
  color: #00ff41;
  text-decoration: none;
  font-size: 14px;
  padding: 8px 16px;
  border: 1px solid #1a1a1a;
  border-radius: 4px;
  transition: all 0.2s;
}

.nav a:hover {
  background: rgba(0, 255, 65, 0.1);
  border-color: #00ff41;
}

/* Main content */
.main-content {
  flex: 1;
  padding: 60px 40px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.hero {
  text-align: center;
  margin-bottom: 80px;
  scroll-margin-top: 80px; /* Account for fixed header if needed */
}

.hero h2 {
  font-size: 48px;
  color: #00ff41;
  margin-bottom: 20px;
  font-weight: 600;
}

.hero p {
  font-size: 18px;
  color: #00ff41;
  opacity: 0.8;
  margin-bottom: 40px;
}

/* Download section */
.download-section {
  margin: 60px 0;
  scroll-margin-top: 80px; /* Account for fixed header if needed */
}

.download-section h3 {
  font-size: 28px;
  color: #00ff41;
  margin-bottom: 30px;
  text-align: center;
}

.download-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.download-btn {
  background: #00ff41;
  color: #000000;
  border: 2px solid #00ff41;
  padding: 16px 32px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-family: inherit;
  text-decoration: none;
  display: inline-block;
}

.download-btn:hover {
  background: rgba(0, 255, 65, 0.2);
  color: #00ff41;
}

/* Features section */
.features {
  margin: 80px 0;
  scroll-margin-top: 80px; /* Account for fixed header if needed */
}

.features h3 {
  font-size: 28px;
  color: #00ff41;
  margin-bottom: 40px;
  text-align: center;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.feature-card {
  background: #0a0a0a;
  border: 1px solid #1a1a1a;
  padding: 30px;
  border-radius: 8px;
  transition: all 0.3s;
}

.feature-card:hover {
  border-color: #00ff41;
  background: rgba(0, 255, 65, 0.05);
}

.feature-card h4 {
  font-size: 20px;
  color: #00ff41;
  margin-bottom: 15px;
}

.feature-card p {
  color: #00ff41;
  opacity: 0.8;
  font-size: 14px;
  line-height: 1.6;
}

/* Footer */
.footer {
  background: #000000;
  border-top: 1px solid #1a1a1a;
  padding: 30px 40px;
  text-align: center;
  color: #00ff41;
  opacity: 0.7;
  font-size: 12px;
}

/* Responsive design */
@media (max-width: 768px) {
  .header {
    padding: 15px 20px;
    flex-direction: column;
    gap: 15px;
  }

  .header h1 {
    font-size: 20px;
  }

  .main-content {
    padding: 40px 20px;
  }

  .hero h2 {
    font-size: 32px;
  }

  .hero p {
    font-size: 16px;
  }

  .download-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .download-btn {
    width: 100%;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }
}

/* Download counter - fixed position in corner */
.download-counter {
  position: fixed;
  bottom: 20px;
  right: 20px;
  color: #00ff41;
  font-family: inherit;
  font-size: 18px;
  font-weight: 400;
  opacity: 0.5;
  z-index: 1000;
  pointer-events: none;
}

@media (max-width: 768px) {
  .download-counter {
    bottom: 10px;
    right: 10px;
    font-size: 16px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/client/app.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,sGAAsG;AACxG;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,iBAAiB;EACjB,YAAY,EAAE,mCAAmC;AACnD;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,iBAAiB;EACjD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB,EAAE,uCAAuC;AAClE;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,uBAAuB,EAAE,uCAAuC;AAClE;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,uBAAuB,EAAE,uCAAuC;AAClE;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* Ash Terminal Theme - Based on ash terminal styling */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nhtml, body {\n  height: 100%;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Courier New', 'Consolas', 'Liberation Mono', monospace;\n}\n\n/* Global scrollbar styling - black theme */\n::-webkit-scrollbar {\n  width: 12px;\n  height: 12px;\n}\n\n::-webkit-scrollbar-track {\n  background: #000000;\n  border-left: 1px solid #1a1a1a;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #2a2a2a;\n  border: 1px solid #3a3a3a;\n  border-radius: 2px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #3a3a3a;\n}\n\n/* Firefox scrollbar */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #2a2a2a #000000;\n}\n\nbody {\n  background: #000000;\n  color: #00ff41;\n  line-height: 1.6;\n  position: relative;\n  overflow-x: hidden;\n}\n\n/* Background Video */\n#background-video {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  transform: translate(-50%, -50%);\n  z-index: -1;\n  object-fit: cover;\n  opacity: 0.3; /* Adjust opacity for readability */\n}\n\n/* Video overlay for better text readability */\n#root::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Dark overlay */\n  z-index: -1;\n  pointer-events: none;\n}\n\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n}\n\n/* Header */\n.header {\n  background: #000000;\n  border-bottom: 1px solid #1a1a1a;\n  padding: 20px 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h1 {\n  font-size: 24px;\n  color: #00ff41;\n  font-weight: 600;\n}\n\n.nav {\n  display: flex;\n  gap: 20px;\n}\n\n.nav a {\n  color: #00ff41;\n  text-decoration: none;\n  font-size: 14px;\n  padding: 8px 16px;\n  border: 1px solid #1a1a1a;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.nav a:hover {\n  background: rgba(0, 255, 65, 0.1);\n  border-color: #00ff41;\n}\n\n/* Main content */\n.main-content {\n  flex: 1;\n  padding: 60px 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.hero {\n  text-align: center;\n  margin-bottom: 80px;\n  scroll-margin-top: 80px; /* Account for fixed header if needed */\n}\n\n.hero h2 {\n  font-size: 48px;\n  color: #00ff41;\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n.hero p {\n  font-size: 18px;\n  color: #00ff41;\n  opacity: 0.8;\n  margin-bottom: 40px;\n}\n\n/* Download section */\n.download-section {\n  margin: 60px 0;\n  scroll-margin-top: 80px; /* Account for fixed header if needed */\n}\n\n.download-section h3 {\n  font-size: 28px;\n  color: #00ff41;\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.download-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.download-btn {\n  background: #00ff41;\n  color: #000000;\n  border: 2px solid #00ff41;\n  padding: 16px 32px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-family: inherit;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.download-btn:hover {\n  background: rgba(0, 255, 65, 0.2);\n  color: #00ff41;\n}\n\n/* Features section */\n.features {\n  margin: 80px 0;\n  scroll-margin-top: 80px; /* Account for fixed header if needed */\n}\n\n.features h3 {\n  font-size: 28px;\n  color: #00ff41;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n}\n\n.feature-card {\n  background: #0a0a0a;\n  border: 1px solid #1a1a1a;\n  padding: 30px;\n  border-radius: 8px;\n  transition: all 0.3s;\n}\n\n.feature-card:hover {\n  border-color: #00ff41;\n  background: rgba(0, 255, 65, 0.05);\n}\n\n.feature-card h4 {\n  font-size: 20px;\n  color: #00ff41;\n  margin-bottom: 15px;\n}\n\n.feature-card p {\n  color: #00ff41;\n  opacity: 0.8;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* Footer */\n.footer {\n  background: #000000;\n  border-top: 1px solid #1a1a1a;\n  padding: 30px 40px;\n  text-align: center;\n  color: #00ff41;\n  opacity: 0.7;\n  font-size: 12px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .header {\n    padding: 15px 20px;\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .header h1 {\n    font-size: 20px;\n  }\n\n  .main-content {\n    padding: 40px 20px;\n  }\n\n  .hero h2 {\n    font-size: 32px;\n  }\n\n  .hero p {\n    font-size: 16px;\n  }\n\n  .download-buttons {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .download-btn {\n    width: 100%;\n  }\n\n  .feature-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Download counter - fixed position in corner */\n.download-counter {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  color: #00ff41;\n  font-family: inherit;\n  font-size: 18px;\n  font-weight: 400;\n  opacity: 0.5;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n@media (max-width: 768px) {\n  .download-counter {\n    bottom: 10px;\n    right: 10px;\n    font-size: 16px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
